import axios from "axios";
import { AES, enc } from 'crypto-js';
import { toast } from "react-toastify";
import { DateRangePicker } from "rsuite";
import CalendarIcon from '../../../ui/CalendarIcon';
import { useNavigate, useParams } from "react-router-dom";
import { ThreeDots } from "react-loader-spinner";
import { ResizeObserver } from 'resize-observer';
import { useSelector, useDispatch } from "react-redux";
import React, { useState, useEffect, useRef } from "react";
import { logout, reset } from "../../../../features/auth/authSlice";
import userTypeConsts from "../../../../constants/userTypeConsts.js";
import { reset as invoiceReset } from "../../../../features/invoice/invoiceSlice.js";
import { setClientInvoiceData } from "../../../../features/client/clientInvoiceSlice.js";
import { reset as headerReset } from "../../../../features/headerText/headerTextSlice.js";
import { reset as appSettingsReset } from "../../../../features/appSettings/appSettingsSlice.js";
import { useGetClients } from "../../../TimeTracker/TimeTrackerOverview/useTimeTracker.jsx";

const ClientsInvoicesModal = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [clientDropdownOpen, setClientDropdownOpen] = useState(false);
  const [clientSearchTerm, setClientSearchTerm] = useState('');
  const [clientSelectedId, setClientSelectedId] = useState('');
  const clientDropdownRef = useRef(null);
  const dropdownListRef = useRef(null);
  const [errorMessage, setErrorMessage] = useState({ message: null, field: null });
  const { appSettings } = useSelector((state) => state.appSettings);
  const [dateRange, setDateRange] = useState(null);

  let token = null;
  const user = useSelector(
    (state) => state.auth.user
  )
  if (user) {
    if (user && user.token) {
      token = user.token;
    }
  }

  const handleSelect = (ranges) => {
    setDateRange(ranges);
    setErrorMessage({ message: null, field: null });
  };
  const SUPER_ADMIN = 1;
  const ADMIN = 2;
  const ref = useRef(null);
  let resizeObserver = null;

  // const { data: userId = [], isLoading: isUserLoading } = useUserById(token);
  const { data: clients = [], isLoading: clientLoading, refetch: refetchClientProfiles, isError: clientError } = useGetClients(token);

  const handleToggleClientDropdown = () => {
    setClientSearchTerm('');
    setClientDropdownOpen((prevOpen) => !prevOpen);
  };

  const handleClientSearchInputChange = (e) => {
    setClientSearchTerm(e.target.value);
  };

  const filteredClients = clients.filter((client) => {
    const fullName = client.client_name
      ? `${client.client_name}`
      : `${client.legal_entity_name}`;
    return fullName?.toLowerCase().includes(clientSearchTerm?.toLowerCase());
  });

  const handleSelectClient = (selectedClientId) => {
    setErrorMessage({ message: null, field: null });
    setClientSelectedId(selectedClientId);
    setClientSearchTerm('');
    setClientDropdownOpen(false);
  };

  const handleClickOutsideDropdown = (event) => {
    const isClickInsideClientDropdown = clientDropdownRef.current && clientDropdownRef.current.contains(event.target);
    if (!isClickInsideClientDropdown) {
      setClientDropdownOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener('click', handleClickOutsideDropdown);
    return () => {
      document.removeEventListener('click', handleClickOutsideDropdown);
    };
  }, []);

  useEffect(() => {
    // Get the selected item
    const selectedItem = document.querySelector('.selected-item');
    // Get the container element
    const dropdownListContainer = dropdownListRef.current;

    // Scroll to the selected item and center it in the view
    if (selectedItem && dropdownListContainer) {
      selectedItem.scrollIntoView({ behavior: 'smooth', block: 'center' });
      // selectedItem.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }
  }, [clientDropdownOpen, clientSearchTerm, filteredClients, clientSelectedId]);

  useEffect(() => {
    // Create a new ResizeObserver instance
    resizeObserver = new ResizeObserver(entries => {
      // Handle resize event
    });

    if (ref.current) {
      // Observe the target element
      resizeObserver.observe(ref.current);
    }

    // Cleanup function
    return () => {
      if (resizeObserver) {
        // Disconnect the observer when component unmounts
        resizeObserver.disconnect();
        resizeObserver = null;
      }
    };
  }, []);

  const clientInvoiceSubmit = async () => {
    var autoData = [];

    if (clientSelectedId === "" || Object.keys(clientSelectedId).length === 0) {
      toast.error("Please select client", {
        position: "bottom-right",
        autoClose: 1500,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      setErrorMessage({ message: "Please Select different date", field: "both" })
      return;
    } else {
    }
    if (dateRange === null) {
      toast.error("Please select date", {
        position: "bottom-right",
        autoClose: 1500,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      return;
    } else if (dateRange[0] === dateRange[1]) {
      toast.error("Please select date", {
        position: "bottom-right",
        autoClose: 1500,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      return;
    } else if (dateRange[0].getTime() === dateRange[1].getTime()) {
      toast.error("Please select different date", {
        position: "bottom-right",
        autoClose: 1500,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      return;
    } else {
      // Convert Date objects to ISO strings for Redux serialization
      const serializedDateRange = dateRange.map(date => date instanceof Date ? date.toISOString() : date);
      autoData.push(serializedDateRange);
      autoData.push(clientSelectedId);
      await dispatch(setClientInvoiceData(autoData));
      navigate(`/client/invoices/create/${encodeURIComponent(AES.encrypt(clientSelectedId, 'encryptionKey').toString().replace(/\//g, '%2F'))}`);
    }
  };

  return (
    <div className="invoice-modal" ref={ref}>
      <h2 className="invoice-modal-main-head">Create Invoice</h2>
      <div className="form-group-1modal userseloutter-1">
        {clientLoading ?
          null :
          <label htmlFor="user-select">Clients *</label>
        }
        {clientLoading ?
          <div className="outter-load-table">
            <ThreeDots
              height="37"
              width="39"
              radius="9"
              color="#6479f9"
              ariaLabel="three-dots-loading"
              wrapperStyle={{}}
              wrapperClassName=""
              visible={true}
            />
          </div> :
          <div ref={clientDropdownRef} className={errorMessage && errorMessage.field === 'both' ? "select-modal-mainM error custom-dropdown-user-new-outer" : "select-modal-mainM custom-dropdown-user-new-outer"}>
            <span
              id="user-select"
              onClick={handleToggleClientDropdown}
              className="custom-dropdown-user-new"
            >
              <span>
                {clientSelectedId
                  ? clients.find((item) => item._id === clientSelectedId)?.client_name
                  : 'Select Client'}
              </span>
              <svg width="18" height="9" viewBox="0 0 18 9" fill="none" xmlns="http://www.w3.org/2000/svg" className="dropdown-chevron-icon" aria-hidden="true">
                <path d="M1.5 1.5L9 7.5L16.5 1.5" stroke="#405BFF" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </span>
            {(user.userType === userTypeConsts.SUPER_ADMIN || user.userType === userTypeConsts.ADMIN || user.userType === userTypeConsts.PROJECT_MANAGER) && clientDropdownOpen && (
              <div className="custom-dropdown-new" ref={dropdownListRef}>
                <input
                  type="text"
                  className="search-bar"
                  placeholder="Search..."
                  value={clientSearchTerm}
                  onChange={handleClientSearchInputChange}
                />
                <ul className="client-list">
                  {filteredClients.length > 0 &&
                    filteredClients
                      .slice()
                      .sort((a, b) =>
                        a.client_name?.toLowerCase().localeCompare(b.client_name?.toLowerCase())
                      )
                      .map((client) => (
                        <li key={client._id} onClick={() => handleSelectClient(client._id)} className={clientSelectedId === client._id ? 'selected-item' : ''}>
                          {client.client_name && `${client.client_name}`}
                        </li>
                      ))
                  }
                </ul>
              </div>
            )
            }
          </div>
        }
      </div>

      <div className="form-group-1modal range-picinmodal-1">
        <label htmlFor="date-range">Date Range *</label>

        <div className="date-picker-outer date-picker-outer-all">
          <div className="custoom-icon-calender custoom-icon-calender-all">
            <DateRangePicker
              showOneCalendar
              className={errorMessage && errorMessage.field === 'both' ? "errorDate" : ""}
              id="date-range"
              format="dd/MM/yyyy"
              character="   to   "
              placeholder="Select a date range"
              value={dateRange}
              onChange={handleSelect}
              placement="auto"
              isoWeek={appSettings.weekStartDay === 'Monday'}
              caretAs={CalendarIcon}
            />
          </div>
        </div>

      </div>
      <div className="form-group-1modal submittseloutter-1">
        <button className="create-button modalsubmitbtn-1" onClick={clientInvoiceSubmit}>
          Create Invoice
        </button>
      </div>
    </div>
  );
};

export default ClientsInvoicesModal;